<template>
  <div class="checkout">
    <checkout-flow :offer="$route.query.offer" />
  </div>
</template>

<script>
import windowStore from '@/store/modules/window.store'

export default {
  name: 'checkout',
  beforeRouteEnter(to, from, next) {
    if (windowStore.state.countryCode !== 'BR') {
      return next({ name: 'inactive' })
    }

    next()
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  // min-height: 100vh;
  background: $login-background;
  padding-bottom: 4em;

  & > .illustration-mosaic {
    display: none;
  }

  .cover-small {
    width: 100%;
  }

  .cover {
    display: none;
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;

    & > .illustration-mosaic {
      display: inline-flex;
    }

    .cover-small {
      display: none;
    }

    .cover {
      display: block;
      width: 728px;
      background: {
        image: url('~@/assets/funweek/bg-large.jpg');
        position: 100% 30px;
        repeat: no-repeat;
        size: 100% auto;
      }
    }
  }
}
</style>
